/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { Button } from 'react-bootstrap'

import './user-profile-redirect.css'

const UserProfileRedirect = ({
  handleRouteNo,
  handleRouteYes,
}: {
  handleRouteNo: any
  handleRouteYes: any
}) => {
  return (
    <div className='submit-bg' id='pageoverlay'>
      <div className='redirectcopying update-section'>
        <p aria-label='Your profile successfully updated! Do you want to submit an inquiry?' className='poppins-semibold font-10 title-color3' id='displaytext' tabIndex={0}  >
          Your profile successfully updated! Do you want to submit an inquiry?
        </p>
        <div className='buttons'>
          <Button
            className='yesbtn btn btn-sm btn-primary whitetext font-11 border-radius ms-auto text-uppercase poppins-semibold'
            onClick={handleRouteYes}
            size='sm'
          // variant='primary'
          >
            Yes
          </Button>
          <Button
            className='btn-border1 title-color3 btn-sm font-11 border-radius text-uppercase poppins-semibold whitebg'
            onClick={handleRouteNo}
            size='sm'
          // variant='secondary'
          >
            No
          </Button>
        </div>
      </div>
    </div>
  )
}

export default UserProfileRedirect
